import React from 'react'
import ModalSimple from '@solid-ui-blocks/Modal/Block02'
import { advertisement, buildAdvertisementContent } from './advertisement'

const AdvertisementModal = props => (
  <ModalSimple content={buildAdvertisementContent(advertisement)} {...props} />
)

export default AdvertisementModal
